module.exports = __webpack_public_path__ + "img/NLD.053c102f.svg";